import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject, debounceTime } from 'rxjs';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent {
  searchForm!: FormGroup;
  private subject: Subject<string> = new Subject();
  @Output() dataEmitter = new EventEmitter<string>();
  @Input() placeholder: any;
  constructor(
    private fb: FormBuilder,
   
  ) {

  }
  onKeyUp(event: any) {
    this.subject.next(event);

  }

  ngOnInit() {
  this.searchForm = this.fb.group({
    search: [''],
    limit: ['10'],
    matchedStatus:['']
  });
  this.subject.pipe(
    debounceTime(1000)
  ).subscribe(searchTextValue => {
    this.dataEmitter.emit(searchTextValue);
  });}
}
